import { render, staticRenderFns } from "./BalanceOutputItem.vue?vue&type=template&id=ff492896&scoped=true"
import script from "./BalanceOutputItem.vue?vue&type=script&lang=js"
export * from "./BalanceOutputItem.vue?vue&type=script&lang=js"
import style0 from "./BalanceOutputItem.vue?vue&type=style&index=0&id=ff492896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff492896",
  null
  
)

export default component.exports